import { UsedProductsFeatureds } from "@/@types";
import { ApiClient } from "../../ApiClient";
import { GetUsedProductsFeaturedResponse } from "../schema/GetUsedProductsFeaturedResponse";
import { mapUsedProductsFeatureds } from "../../mappers/usedProductFeaturedMapper";

export const getFeatureds = async (): Promise<UsedProductsFeatureds[]> => {
  const client = ApiClient.getInstance();
  
  const response = await client.get<GetUsedProductsFeaturedResponse>('used-products/featured');
  
  const mappedResponse = mapUsedProductsFeatureds(response);
  
  return mappedResponse;
};
